export const DEFAULT_CHAT = {
    title: 'Untitled Project',
    messages: [],
};
